export const plus = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8 6.003a.8.8 0 0 0-1.6 0v5.2H6a.8.8 0 0 0 0 1.6h5.2v5.2a.8.8 0 1 0 1.6 0v-5.2H18a.8.8 0 1 0 0-1.6h-5.2v-5.2z" fill="var(--theme-primary, #810ea9)"/>
</svg>`;
